import { downloadFile, getIdOrNull, requestMultipart, requestWithPromise } from '..'
import { getDataOrDefault, HttpMethods, makeQueryString } from '../apiHelper'
import apiClient from './apiClient'

export const getInstitution = (user, institution, parameters = {}) => {
  return requestWithPromise(
    `/api/institutions/${getIdOrNull(institution)}${makeQueryString(parameters)}`,
    HttpMethods.GET,
    null,
    user
  )
}

export const fetchInstitutionSchools = (institution, user) => {
  return requestWithPromise(
    `/api/institutions/${getIdOrNull(institution)}/schools`,
    HttpMethods.GET,
    null,
    user
  )
}

const DEFAULT_PARAMETERS_GET_INSTITUTION_SECTORS = { archived: false, strictMode: false }
export const getInstitutionSectors = (user, institution, queryParameters = DEFAULT_PARAMETERS_GET_INSTITUTION_SECTORS) =>
  apiClient.get(user, `api/institutions/${institution.id}/sectors`, queryParameters)

export const updateInstitutionOption = (user, option, body) =>
  apiClient.patch(user, `api/institutions/${getIdOrNull(option.institution)}/institution-options/${getIdOrNull(option)}`, body)

export const fetchInstitutionScore = (user, institution, endDate, startDate, additionalData) => {
  return requestWithPromise(
    `/institution/${getIdOrNull(institution)}/evaluation-internships/score?end-date=${endDate}&start-date=${startDate}&additional-data=${additionalData}`,
    HttpMethods.GET,
    null,
    user
  ).then(getDataOrDefault())
}

export const getAllInstitutions = (user, parameters = {}) => apiClient.get(user, 'api/institutions', parameters)

export const getInstitutionDocuments = (user, institution) => {
  return requestWithPromise(
    `/api/institutions/${getIdOrNull(institution)}/documents`,
    HttpMethods.GET,
    null,
    user
  )
}

export const getInstitutionShiftPresets = (user, institution) => {
  return requestWithPromise(
    `/api/institutions/${getIdOrNull(institution)}/shift-presets`,
    HttpMethods.GET,
    null,
    user
  )
}

export const getInstitutionUsers = (user, institution, parameters = {}) => {
  return requestWithPromise(
    `/api/institutions/${getIdOrNull(institution)}/users${makeQueryString(parameters)}`,
    HttpMethods.GET,
    null,
    user
  )
}

export const updateInstitution = (user, institution) => apiClient.patch(user, `api/institutions/${getIdOrNull(institution)}`, institution)

export const deleteInstitution = (user, institution, parameters = {}) => {
  return requestWithPromise(
    `/api/institutions/${getIdOrNull(institution)}${makeQueryString(parameters)}`,
    HttpMethods.DELETE,
    null,
    user
  )
}

/** @deprecated 2024-01-16 */
export const deleteInstitutionOld = (user, institution) => {
  return requestWithPromise(
    '/api/Institution/' + getIdOrNull(institution),
    HttpMethods.DELETE,
    null,
    user
  )
}

export const createInstitution = (user, institution) => apiClient.post(user, 'api/institution', institution)

export const getDesiderataLimitValue = (institution, user, parameters) => {
  return requestWithPromise(
    `/api/institutions/${getIdOrNull(institution)}/desiderata-limit${makeQueryString(parameters)}`,
    HttpMethods.GET,
    null,
    user
  )
}

export const linkSchoolToInstitution = (user, institution, school) => {
  return requestWithPromise(
    `/api/institutions/${getIdOrNull(institution)}/schools`,
    HttpMethods.POST,
    { school: getIdOrNull(school) },
    user
  )
}

export const unlinkSchoolFromInstitution = (user, institution, school) => {
  return requestWithPromise(
    `/api/institutions/${getIdOrNull(institution)}/schools/${getIdOrNull(school)}`,
    HttpMethods.DELETE,
    null,
    user
  )
}

export const linkAreaInstitution = (user, institution, areas) => {
  return requestWithPromise(
    `/api/institutions/${getIdOrNull(institution)}/areas`,
    HttpMethods.PATCH,
    { areas },
    user
  )
}

export const unLinkAreaInstitution = (user, institution, areas) => {
  return requestWithPromise(
    `/api/institutions/${getIdOrNull(institution)}/areas${makeQueryString({ areas })}`,
    HttpMethods.DELETE,
    null,
    user
  )
}

export const getInstitutionEvaluationQuestions = (user, institution) => {
  return requestWithPromise(
    `/evaluation/questions/${getIdOrNull(institution)}`,
    HttpMethods.GET,
    null,
    user
  )
}

export const uploadInstitutionDocument = (user, institution, file) => {
  return requestMultipart(
    '/institution/document/upload',
    HttpMethods.POST,
    {
      'document[institution]': getIdOrNull(institution),
      file
    },
    user
  )
}

export const downloadInstitutionDocument = (user, document) => {
  return downloadFile(`/institution/document/download/${getIdOrNull(document)}`, document.originalName, user)
}

export const deleteInstitutionDocument = (user, document) => {
  return requestWithPromise(
    `/api/InstitutionDocument/${getIdOrNull(document)}`,
    HttpMethods.DELETE,
    null,
    user
  )
}

export const getInstitutionOptions = (user, institution) => apiClient.get(user, `api/institutions/${getIdOrNull(institution)}/institution-options-with-params`)

export const getOptionEnabledByInstitution = (user, institution, optionType) => apiClient.get(user, `api/institutions/${institution.id}/option-enabled`, { institutionOptionType: optionType })

export const getInstitutionRejectionReasons = (user, institution) => apiClient.get(user, `api/institutions/${getIdOrNull(institution)}/rejection-reasons`)

export const getInstitutionSectorsFilesCount = (user, institution) => apiClient.get(user, `api/institutions/${getIdOrNull(institution)}/sectors/documents`)

export const getInstitutionOptionsEnabledByInstitution = (institution, optionTypes = []) =>
  apiClient.get(
    null,
    `public/institutions/${getIdOrNull(institution)}/institution-options`,
    { institutionOptionTypes: optionTypes }
  )
